export interface shelfRack {
  id: string;
  shelfNumber: string;
  rackNumber: string;
  rackType: string;
  isActiveShelfRack: boolean;
  vaultName: string;
  aisleNumber?:string
}

export const ShelfRackInitialState = {
  id: '',
  shelfNumber: '',
  rackNumber: '',
  rackType: '',
  isActiveShelfRack: false,
  vaultName: '',
  aisleNumber:''
};

export interface shelfRoom{
  vault: string;
  room: string;
  aisle_No: string;
  shelf: string;
}

export const shelRoomInitialState={
  vault:'',
  room:'',
  aisle_No:'',
  shelf:'',
}